import {
  useGetProfileListNameIdQuery,
  type LocationFilter,
} from "@package/ui-gql/index-data-access";
import { type WritableDraft } from "immer";
import { uniq } from "lodash";
import { useMemo, useState } from "react";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = LocationFilter | null | undefined;

export function ItemGridFilterProfiles() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();
  const { data, loading, error } = useGetProfileListNameIdQuery({
    variables: {
      page: 0,
      perPage: 1000,
      sortField: "name",
      sortOrder: "ASC",
      filter: (query && { q: query }) || undefined,
    },
  });

  const filterWithProfiles: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      data?.items
        ?.slice()
        ?.filter((item) => !!item?.id)
        ?.map((item) => {
          const id = item.id ?? "";
          const name = item.name ?? "";
          const checked = filterWithProfiles?.profile?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        }) ?? [];

    return values;
  }, [data?.items, filterWithProfiles?.profile]);

  return (
    <ItemGridFilterDataList
      error={error}
      items={items}
      loading={loading}
      property="profile"
      text="Canvas"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.profile;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.profile = uniq([...(draft.profile ?? []), id]);
            } else if (draft.profile?.length) {
              draft.profile = draft.profile.filter((layout) => layout !== id);
            }

            if (!draft.profile?.length) {
              delete draft.profile;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        if (checked) {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              draft.profile = items.map((item) => item.id);
            }
          });
        } else {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              delete draft.profile;
            }
          });
        }
      }}
    />
  );
}
